import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';

@Component({
  selector: 'piqet-angular-new-circular-economy-parameter',
  templateUrl: './new-circular-economy-parameter.component.html',
  styleUrls: ['./new-circular-economy-parameter.component.scss'],
})
export class NewCircularEconomyParameterComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  circularEconomyParameterData: any;
  circularEconomyParameterAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  materialList: any;
  selectOrganization: any;
  organizationlist: any;
  isDisableDropDown!: boolean;

  @Output() saveNewCircularEconomyParameterEvent = new EventEmitter<any>();

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private administratorService: AdministratorService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.circularEconomyParameterData =
      this.modal?.modalService?.config?.initialState?.['newCircularEconomyParameterData'];
    this.isDisableDropDown =
      this.modalLabel == 'Review circular economy parameter detail' ? true : false;

    const newOrganizationlist = this.circularEconomyParameterData.organizationList;

    const newMaterialist = this.circularEconomyParameterData.materialItems;

    this.organizationlist = newOrganizationlist;
    this.materialList = newMaterialist;
    this.organizatioListFunction();
  }

  ngOnInit(): void {
    this.circularEconomyParameterAddEditForm = this.formBuilder.group({
      material: [this.circularEconomyParameterData.materialId || null, Validators.required],
      organizationName: [
        this.circularEconomyParameterData.organizationId || this.organizationlist[0] || null,
      ],
      EC_EfficiencyRecyclingEOL: [
        this.circularEconomyParameterData.circularEconomyParameterData?.eC_EfficiencyRecyclingEOL ||
          0,
        Validators.required,
      ],
      EF_EfficiencyOfRecyclingForInputMaterial: [
        this.circularEconomyParameterData.circularEconomyParameterData
          ?.eF_EfficiencyOfRecyclingForInputMaterial || 0,
        Validators.required,
      ],
    });
    this.setFormData();
  }

  onClose() {
    this.modal.close();
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }
  commonInputSearchForMaterial(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }
  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.circularEconomyParameterData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }
  setFormData() {
    this.circularEconomyParameterAddEditForm.patchValue({
      organizationName: this.selectOrganization,
    });
  }

  onSave() {
    this.submitted = true;
    if (this.circularEconomyParameterAddEditForm.invalid) {
      return;
    }
    const data = {
      circularEconomyParameterId: this.circularEconomyParameterData.circularEconomyParameterId || 0,
      materialId: this.circularEconomyParameterData.materialId || 0,
      eC_EfficiencyRecyclingEOL:
        this.circularEconomyParameterAddEditForm.controls['EC_EfficiencyRecyclingEOL'].value,
      eF_EfficiencyOfRecyclingForInputMaterial:
        this.circularEconomyParameterAddEditForm.controls[
          'EF_EfficiencyOfRecyclingForInputMaterial'
        ].value,
    };
    const saveCustomFillingData = {
      materialId:
        this.circularEconomyParameterAddEditForm.controls['material'].value ||
        this.circularEconomyParameterData.materialId,
      organizationId:
        this.circularEconomyParameterAddEditForm.controls['organizationName'].value?.name ==
          'All organization' ||
        this.circularEconomyParameterAddEditForm.controls['organizationName'].value?.name ==
          undefined
          ? null
          : this.circularEconomyParameterAddEditForm.controls['organizationName'].value?.id,
      circularEconomyParameterData: data,
    };
    this.saveNewCircularEconomyParameterEvent.emit(saveCustomFillingData);
  }
}
